import { useContext, useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader, ButtonModifier } from "../../../components";
import { formatDate } from "../../../constants/helper";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Button, ButtonGroup } from "@mui/material";
import jsPDF from "jspdf";
import { NumericFormat } from "react-number-format";
import PrintIcon from "@mui/icons-material/Print";
import SearchIcon from "@mui/icons-material/Search";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilPembayaranPiutang = () => {
  const screenSize = useScreenWidth();
  const reportTemplateRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isPost, setIsPost] = useState("");

  // Data Penerimaan Piutang
  const [penjualanId, setPenjualanId] = useState("");
  const [tglPembayaranPiutang, setTglPembayaranPiutang] = useState("");

  // Data Penjualan
  const [noNotaPenjualan, setNoNotaPenjualan] = useState("");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [noTeleponCustomer, setNoTeleponCustomer] = useState("");
  const [saldoPiutang, setSaldoPiutang] = useState("0");
  const [totalBayar, setTotalBayar] = useState("0");
  const [kodeCOA, setKodeCOA] = useState("");
  const [keterangan, setKeterangan] = useState("");

  const navigate = useNavigate();
  let today = new Date();
  let isEditableManager = user.tipeUser !== "ADMIN" && isPost === false;
  let isEditableAdmin = true;
  // let isEditableAdmin =
  //   user.tipeUser === "ADMIN" &&
  //   tglPembayaranPiutangDate?.getFullYear() === today.getFullYear() &&
  //   tglPembayaranPiutangDate?.getMonth() === today.getMonth() &&
  //   tglPembayaranPiutangDate?.getDate() === today.getDate() &&
  //   isPost === false;
  let isEditable = isEditableManager || isEditableAdmin;

  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getPembayaranPiutangById();
  }, []);

  const getPembayaranPiutangById = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/pembayaranPiutangs/${id}`, {
      _id: user.id,
      token: user.token,
    });
    setIsPost(response.data.isPost);

    // Data Penerimaan Piutang
    setPenjualanId(response.data.penjualan.id);
    setTglPembayaranPiutang(formatDate(response.data.tglPembayaranPiutang));

    // Data Penjualan
    setNoNotaPenjualan(response.data.penjualan.noNotaPenjualan);
    setNamaCustomer(response.data.penjualan.namaCustomer);
    setNamaCustomer(
      `${response.data.penjualan.nopolCustomer} - ${response.data.penjualan.namaCustomer}`
    );
    setNoTeleponCustomer(
      response.data.penjualan.noTeleponCustomer
        ? response.data.penjualan.noTeleponCustomer
        : ""
    );
    setSaldoPiutang(
      response.data.penjualan.total - response.data.penjualan.totalBayar
    );
    setTotalBayar(response.data.totalBayar);
    setKodeCOA(
      response.data.coa &&
        `${response.data.coa.kodeCOA} - ${response.data.coa.namaCOA}`
    );
    setKeterangan(response.data.keterangan);

    setLoading(false);
  };

  const deletePembayaranPiutang = async (id) => {
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deletePembayaranPiutang/${id}`, {
        penjualanId,
        totalBayar,
        _id: user.id,
        token: user.token,
      });
      navigate("/daftarPembayaranPiutang");
    } catch (error) {
      alert(error.response.data.message);
    }
    setLoading(false);
  };

  const handleGeneratePdf = () => {
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
    });

    doc.html(reportTemplateRef.current, {
      async callback(doc) {
        window.open(URL.createObjectURL(doc.output("blob")));
      },
      html2canvas: { scale: 0.44 },
    });
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Penerimaan Piutang</h5>
      <hr />
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate("/daftarPembayaranPiutang")}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>

      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              setPreviewPdf(!previewPdf);
            }}
          >
            CETAK
          </Button>
        </ButtonGroup>
      </Box>

      <Box sx={buttonModifierContainer}>
        {isEditable && (
          <>
            <ButtonModifier
              id={id}
              kode={"test"}
              addLink={null}
              editLink={`/daftarPembayaranPiutang/pembayaranPiutang/${id}/edit`}
              deleteUser={deletePembayaranPiutang}
              nameUser={tglPembayaranPiutang}
            />
          </>
        )}
      </Box>

      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={handleGeneratePdf}
          >
            CETAK
          </Button>
          <div ref={reportTemplateRef} style={cetakContainerKwitansi}>
            <p style={cetakText}>{setting.namaPerusahaan}</p>
            <p style={cetakText}>
              {setting.alamatPerusahaan} ({setting.kabupatenPerusahaan}){" "}
              {setting.kotaPerusahaan}
            </p>
            <p style={cetakText}>TELP. {setting.teleponPerusahaan}</p>
            <p style={cetakCenter}>
              <b>NOTA PENJUALAN</b>
            </p>
            <div style={{ display: "flex", marginTop: "10px" }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex" }}>
                  <div style={{ flex: 1 }}>
                    <span>Terima Dari</span>
                  </div>
                  <div style={{ flex: 2 }}>
                    <span>:</span>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ display: "flex", textAlign: "center" }}>
              <div style={{ flex: 1 }}>
                <div>
                  <p>Bag. PembayaranPiutang</p>
                  <p style={{ marginTop: "60px" }}>( {user.username} )</p>
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <div>
                  <p>Mengetahui,</p>
                  <div style={{ marginTop: "60px" }}>
                    <span>(</span>
                    <span style={{ marginLeft: "140px" }}>)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Form>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Penjualan</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Nota Penjualan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={noNotaPenjualan} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={namaCustomer} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Telepon :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={noTeleponCustomer} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tanggal :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={tglPembayaranPiutang} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Saldo Piutang :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          value={saldoPiutang}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jumlah Bayar :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          value={totalBayar}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        COA :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={kodeCOA} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Keterangan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={keterangan} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>
      </Form>
    </Container>
  );
};

export default TampilPembayaranPiutang;

const buttonModifierContainer = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const tableChildWrapper = {
  mt: 4,
  height: "400px",
  overflowY: "auto",
  border: "1px solid #e0e0e0",
};

const downloadButtons = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const cetakContainerKwitansi = {
  fontSize: "14px",
  letterSpacing: "0.01px",
  fontFamily: "sans-serif",
  // width: "330px",
  padding: "20px",
  // marginLeft: "35px",
  marginLeft: "15px",
};

const cetakCenter = {
  // fontSize: "12px",
  fontSize: "14px",
  textAlign: "center",
  marginTop: "0px",
  marginBottom: "0px",
};

const cetakText = {
  // fontSize: "12px",
  fontSize: "14px",
  marginTop: "0px",
  marginBottom: "0px",
};

const cetakTableTotal = {
  border: "1px solid white",
  borderLeft: "1px solid black",
  borderRight: "1px solid black",
  height: "10px",
  lineHeight: "10px",
  padding: "0 0px",
};

const cetakTableTotalTerakhir = {
  border: "1px solid white",
  borderLeft: "1px solid black",
  borderRight: "1px solid black",
  borderBottom: "1px solid black",
  height: "10px",
  lineHeight: "10px",
  padding: "0 0px",
};
